import { ServiceType } from '@wix/ambassador-bookings-services-v2-service/types';
export const isFeatureEnabled = _ref => {
  let {
    activeFeatures,
    service
  } = _ref;
  const serviceTypeActiveFeatureMap = {
    [ServiceType.APPOINTMENT]: 'applicableForIndividual',
    [ServiceType.COURSE]: 'applicableForCourse',
    [ServiceType.CLASS]: 'applicableForGroups'
  };
  const activeFeaturesKey = serviceTypeActiveFeatureMap[service.type];
  return activeFeaturesKey ? !!activeFeatures[activeFeaturesKey] : true;
};
//# sourceMappingURL=activeFeature.js.map